import React, { useState } from "react";
import { api } from "../../../../lib/api";
import { toast } from "sonner";

export function RegenerateQrPanel() {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const run = async () => {
    setBusy(true);
    setResult(null);
    try {
      const r = await api.post("/admin/regenerate-qr-payloads");
      setResult(r.data);
      const s = r.data?.summary || {};
      toast.success(`Updated ${s.updated || 0} QR payloads · pointing at ${r.data?.base_url || "?"}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Regeneration failed");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-5 rounded-xl bg-[#184A30]/5 border border-[#184A30]/20 p-5" data-testid="regenerate-qr-panel">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <p className="serif text-lg text-[#112318]">Regenerate QR payloads</p>
          <p className="text-xs text-[#4A5C50] mt-1 leading-relaxed max-w-xl">
            Rewrites every active card&apos;s <span className="mono">qr_payload</span> to use
            the current <span className="mono">PUBLIC_BASE_URL</span> and the correct
            <span className="mono"> /pay?last4=…</span> route. Run this after changing the
            public base URL (e.g. preview → production) so existing cards&apos; QR codes
            still resolve to your Pay-with-QR page.
          </p>
        </div>
        <button type="button" disabled={busy} onClick={run}
          className="px-4 py-2 rounded-lg bg-[#184A30] hover:bg-[#0E3320] text-[#FBF9F6] text-sm font-medium disabled:opacity-50"
          data-testid="regenerate-qr-run-btn">
          {busy ? "Regenerating…" : "Regenerate QR codes"}
        </button>
      </div>
      {result && (
        <div className="mt-4 text-xs text-[#4A5C50] space-y-1 mono" data-testid="regenerate-qr-result">
          <p>Scanned: {result.summary?.scanned || 0} · Updated: {result.summary?.updated || 0} · Skipped: {result.summary?.skipped || 0}</p>
          <p className="opacity-70">New base: {result.base_url}</p>
        </div>
      )}
    </div>
  );
}
